import { render, staticRenderFns } from "./AllCompetitorsGrid.vue?vue&type=template&id=5bd9b836&scoped=true&"
import script from "./AllCompetitorsGrid.vue?vue&type=script&lang=js&"
export * from "./AllCompetitorsGrid.vue?vue&type=script&lang=js&"
import style0 from "./AllCompetitorsGrid.vue?vue&type=style&index=0&id=5bd9b836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd9b836",
  null
  
)

/* custom blocks */
import block0 from "@/javascripts/grid.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fapp%2Fjavascript%2Fpages%2FCompetitors%2FGrids%2FAllCompetitorsGrid.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./AllCompetitorsGrid.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports